import { render, staticRenderFns } from "./MobileAppFooter.vue?vue&type=template&id=6f6ef232&scoped=true"
import script from "./MobileAppFooter.vue?vue&type=script&lang=js"
export * from "./MobileAppFooter.vue?vue&type=script&lang=js"
import style0 from "./MobileAppFooter.vue?vue&type=style&index=0&id=6f6ef232&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6ef232",
  null
  
)

export default component.exports